<script setup lang="ts">
// Корень приложения: страница в общей раскладке (или без неё — meta.layout: false), ошибки страниц — ErrorPage.
import { defineAsyncComponent, onErrorCaptured, watch } from 'vue';
import { useRoute, type RouteLocationNormalizedLoaded } from 'vue-router';
import DefaultLayout from '@/layouts/DefaultLayout.vue';
const SnimkLayout = defineAsyncComponent(() => import('@platform/faculties/snimk/ui/SnimkLayout.vue'));
import ErrorPage from '@/ErrorPage.vue';
import { pageError, showError, takeDeferredError } from '@/runtime/errors';
import PageScope from '@/PageScope.vue';

const route = useRoute();
// Ключ страницы — верхний маршрут с параметрами: вложенный маршрут (событие → правка) не пересоздаёт родителя.
const pageKey = (current: RouteLocationNormalizedLoaded) => current.matched[0] ? `${current.matched[0].path}|${JSON.stringify(current.params)}` : current.path;
watch(() => route.fullPath, () => { pageError.value = takeDeferredError(); }, { immediate: true });
onErrorCaptured(error => {
  const value = error as { statusCode?: number; message?: string; name?: string };
  // Ошибки страниц (createError) и ответов API при загрузке показываем страницей ошибки.
  if (value?.name === 'PageError' || value?.name === 'ApiError' || typeof value?.statusCode === 'number') {
    showError(value);
    return false;
  }
  console.error(error);
  showError({ statusCode: 500 });
  return false;
});
</script>

<template>
  <ErrorPage v-if="pageError" :error="pageError" />
  <RouterView v-else v-slot="{ Component, route: current }">
    <Suspense>
      <PageScope v-if="current.meta.layout === false" :key="pageKey(current)" :route="current">
        <component :is="Component" />
      </PageScope>
      <SnimkLayout v-else-if="current.meta.snimk">
        <PageScope :key="pageKey(current)" :route="current">
          <component :is="Component" />
        </PageScope>
      </SnimkLayout>
      <DefaultLayout v-else>
        <PageScope :key="pageKey(current)" :route="current">
          <component :is="Component" />
        </PageScope>
      </DefaultLayout>
    </Suspense>
  </RouterView>
</template>
